var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightNoCircle(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 10 8",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.354 4.354a.5.5 0 000-.708L6.172.464a.5.5 0 10-.708.708L8.293 4 5.464 6.828a.5.5 0 10.708.708l3.182-3.182zM0 4.5h9v-1H0v1z"
  })));
}

var MemoSvgArrowRightNoCircle = /*#__PURE__*/React.memo(SvgArrowRightNoCircle);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEwIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05LjM1MzU1IDQuMzUzNTVDOS41NDg4MiA0LjE1ODI5IDkuNTQ4ODIgMy44NDE3MSA5LjM1MzU1IDMuNjQ2NDVMNi4xNzE1NyAwLjQ2NDQ2NkM1Ljk3NjMxIDAuMjY5MjA0IDUuNjU5NzMgMC4yNjkyMDQgNS40NjQ0NyAwLjQ2NDQ2NkM1LjI2OTIgMC42NTk3MjggNS4yNjkyIDAuOTc2MzExIDUuNDY0NDcgMS4xNzE1N0w4LjI5Mjg5IDRMNS40NjQ0NyA2LjgyODQzQzUuMjY5MiA3LjAyMzY5IDUuMjY5MiA3LjM0MDI3IDUuNDY0NDcgNy41MzU1M0M1LjY1OTczIDcuNzMwOCA1Ljk3NjMxIDcuNzMwOCA2LjE3MTU3IDcuNTM1NTNMOS4zNTM1NSA0LjM1MzU1Wk0wIDQuNUg5VjMuNUgwTDAgNC41WiIgZmlsbD0iI0RGNEI4NSIvPgo8L3N2Zz4K";
export { MemoSvgArrowRightNoCircle as ReactComponent };